var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('ButtonComponent',{attrs:{"variant":"secondary"},on:{"click":_vm.edit}},[(_vm.$slots.prepend)?[_vm._t("prepend")]:_vm._e(),(_vm.editing)?[_c('input',{ref:"input",attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.handleInput}})]:[_vm._t("default")]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }